import React from "react";
import Home from "../../../../assets/icons/TabBar/home_disabled.svg";
import HomeActive from "../../../../assets/icons/TabBar/home_active.svg";
import Reserve from "../../../../assets/icons/TabBar/reserve_disabled.svg";
import ReserveActive from "../../../../assets/icons/TabBar/reserve_active.svg";
import Report from "../../../../assets/icons/TabBar/report_disabled.svg";
import ReportActive from "../../../../assets/icons/TabBar/report_active.svg";
import Mypage from "../../../../assets/icons/TabBar/mypage_disabled.svg";
import MypageActive from "../../../../assets/icons/TabBar/mypage_active.svg";
import Camera from "../../../../assets/image/icon/main_camera.png";

const menuList = [
    { key: "home", label: "오늘 홍보", icon: Home, activeIcon: HomeActive },
    { key: "reserve", label: "자동업로드", icon: Reserve, activeIcon: ReserveActive },
    { key: "report", label: "코칭", icon: Report, activeIcon: ReportActive },
    { key: "mypage", label: "내 매장", icon: Mypage, activeIcon: MypageActive },
];

const AdsMenuBar = ({ tab, setTab, onCameraClick }) => {
    const left = menuList.slice(0, 2);
    const right = menuList.slice(2);

    return (
        <div
            className="
                ui-textlock
                bg-white
                w-full
                px-2 py-[10px]
                flex items-end justify-between
                select-none
            "
        >
            <div className="flex flex-1 items-center justify-start">
                {left.map((item) => {
                    const isActive = item.key === tab;
                    return (
                        <button
                            key={item.key}
                            onClick={() => setTab(item.key)}
                            className="flex flex-col items-center justify-center flex-1 min-w-0 cursor-pointer gap-[6px] leading-[18px]"
                            type="button"
                        >
                            <img
                                src={isActive && item.activeIcon ? item.activeIcon : item.icon}
                                alt={`${item.label} 아이콘`}
                                className="w-[24px] h-[24px] shrink-0 object-contain pointer-events-none"
                                draggable={false}
                            />
                            <span
                                className={`${isActive ? "text-text-primary text-c1" : "text-text-disabled text-c2"} truncate`}
                                style={{ letterSpacing: 0 }}
                            >
                                {item.label}
                            </span>
                        </button>
                    );
                })}
            </div>

            <div className="px-2">
                <button
                    type="button"
                    onClick={() => onCameraClick?.()}
                    className="w-[60px] h-[60px] rounded-full bg-[#7864F9] flex items-center justify-center -translate-y-1 shadow-[0_6px_14px_rgba(0,0,0,0.18)]"
                >
                    <img
                        src={Camera}
                        alt="카메라"
                        className="w-[30px] h-[30px] object-contain pointer-events-none"
                        draggable={false}
                    />
                </button>
            </div>

            <div className="flex flex-1 items-center justify-end">
                {right.map((item) => {
                    const isActive = item.key === tab;
                    return (
                        <button
                            key={item.key}
                            onClick={() => setTab(item.key)}
                            className="flex flex-col items-center justify-center flex-1 min-w-0 cursor-pointer gap-[6px] leading-[18px]"
                            type="button"
                        >
                            <img
                                src={isActive && item.activeIcon ? item.activeIcon : item.icon}
                                alt={`${item.label} 아이콘`}
                                className="w-[24px] h-[24px] shrink-0 object-contain pointer-events-none"
                                draggable={false}
                            />
                            <span
                                className={`${isActive ? "text-text-primary text-c1" : "text-text-disabled text-c2"} truncate`}
                                style={{ letterSpacing: 0 }}
                            >
                                {item.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default AdsMenuBar;
